<script>
  import {userStore, cities, countries, is} from '../../store'
  import { createEventDispatcher, onMount } from 'svelte'
  import { push, location, querystring } from 'svelte-spa-router'
  import L from 'leaflet'
  import { MarkerClusterGroup } from 'leaflet.markercluster'
  import DataTable from '../DataTable/DataTable.svelte'
  import Button from 'smelte/src/components/Button'
  import EditForm from './EditForm/EditForm.svelte'
  import { parseQuery, setQueryParam } from './urlQuery'
  import { installedBaseAPI } from './api.js'
  import Icon from 'fa-svelte'
  import { faInfo, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
  import { setCookie } from 'tiny-cookie'
  import FiltersComp from './FiltersComp.svelte'
  import { exportToXls } from './utils'
  import BlueButton from "./BlueButton.svelte"
  import ConfirmationPopup from "./ConfirmationPopup.svelte"

  export let params = {}

  // refactored params
  export let locationLabel = ''
  export let columns = []
  export let actions = []
  export let actionsLabel = 'Actions'
  export let filters = {}
  export let getMachines = function (locations, selectedLocation, machines) {
    // abstract
    return []
  }
  export let setLocationID = function (l) {
    // abstract
    return 0
  }
  export let locationsHandler = ''
  export let mapTrigger = 0
  export let exportColumns = []

  const dispatch = createEventDispatcher()
  const api = new installedBaseAPI()

  // this view depends on mode: projects or conveyors
  // detail param might be a project or conveyor data
  let getProjectData = async function (su_erp_proj) {
    const res = await api.getProject(su_erp_proj)
    // console.log('[DEBUG] getProjectData', res.data)
    if (!res || !res.data) {
      return {}
    }
    return res.data
  }

  let mymap
  let selected = ''
  let previous = ''
  let selectedLocation = null
  let showFilters = false

  let attributes = []

  let loading = true
  let locations = []
  let locationsPromise = null
  let detailsForm = null
  let edit = false
  let form = false

  let mCount = 0
  let machines = []
  let markers = {}
  let cluster = {}
  let north = 80, south = -80, east = 180, west = -180
  let mapFilter = true

  let lastSelectedMarker = null

  let _loc = $location.toString()

  let salesOfficeLocation = null

  const activeIcon = L.icon({
    iconUrl: 'static/img/marker-red.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [-3, -76],
    shadowSize: [41, 41],
    shadowUrl: 'static/img/marker-shadow.png',
    tooltipAnchor: [16, -28]
  })

  let filtered1 = []
  let filteredByMap = []

  $: {
    getState($querystring)
  }

  $: {
    setState(selected, detailsForm, edit, selectedLocation)
  }

  $: init(selected, locations.length, form)

  async function init () {
    selectedLocation = locations.find(l => l.no === selected)
    if (selectedLocation) {
      setMarker(selectedLocation)
    }
    if (!detailsForm && selectedLocation && form) {
      detailsForm = form ? await getProjectData(selectedLocation.su_erp_proj) : null
    }
  }

  $: {
    filterByMap(north, east, filtered1.length, mapTrigger)
  }

  let proceedConfirmed = false
  let showConfirmationDialog = false
  $: {
    if (proceedConfirmed) {
      proceedConfirmed = false
      console.log('[DEBUG] export columns:', exportColumns)
      // exportToCSV(filteredByMap.slice(0, 30), exportColumns)
      exportToXls(filteredByMap.slice(0, 30), exportColumns)
    }
  }

  onMount(async () => {
    const res = await api.getSalesOfficeLocation()
      .catch(err => console.log('[ERROR]', err))

    salesOfficeLocation = res.data
    console.log('[DEBUG] Sales Office Location:', salesOfficeLocation)

    await mapBox()
    let xy = [60.7913, 9.2266]
    let zoom = 4
    // const cookie = getCookie('map')
    // if (cookie != null) {
    //   const mapParams = JSON.parse(cookie)
    //   console.log('[DEBUG] map cookie is', cookie)
    //   if (mapParams.lat != null && mapParams.lng != null) {
    //     xy = [mapParams.lat, mapParams.lng]
    //     zoom = mapParams.zoom
    //   }
    // } else {
    //   // console.log('[DEBUG] cookie is null',)
    //   removeCookie('map')
    // }

    if (salesOfficeLocation && Array.isArray(salesOfficeLocation.p)) {
      xy = salesOfficeLocation.p
      zoom = salesOfficeLocation.zoom
    }

    console.log('[DEBUG] xy, zoom', xy, zoom)
    mymap.setView(xy, zoom)

    getBounds()

    getData()
    //updateMap(locations)

    api.getCities()
      .then(res => {
        $cities = res.data
        const list = res.data?.map(p => p.country) ?? []
        const uniqueOnly = (v, i, a) => v !== '' && a.indexOf(v) === i
        $countries = list.filter(uniqueOnly, []).sort((a, b) => a < b ? -1 : 1)
      })
      .catch(err => console.log('[ERROR]', err.message))
  })

  // set state, objects from URL from query string
  async function getState () {
    let queryObj = parseQuery($querystring)
    if (queryObj.id != null) {
      selected = queryObj.id // parseInt(queryObj.id, 10)
    }
    edit = queryObj.edit === 'true'
    form = queryObj.form === 'true'
  }

  // set URL query string from objects
  function setState () {
    if (selected == null || selected === '') {
      return
    }
    let q = setQueryParam($querystring, 'id', selected)
    if (selectedLocation != null) {
      q = setQueryParam(q, 'edit', detailsForm && edit ? true : null)
      q = setQueryParam(q, 'form', detailsForm ? true : null)
    }
    if ($location.toString() === _loc) {
      push($location + '?' + q)
    }
  }

  function filterByMap (north, east, filtered1_length) {
    // console.log('[DEBUG] filterByMap ...',)
    // getBounds()
    filteredByMap = [...filtered1.filter(p => isFitMapBounds(p))]
    if (selectedLocation != null) {
      setMarker(selectedLocation, true)
    }

    // console.log('[DEBUG] filteredByMap', filteredByMap.slice(0, 10))
  }

  function isFitMapBounds (location) {
    if (!mapFilter) {
      return true
    }
    return location.lat > south && location.lat < north && location.lon > west && location.lon < east
  }

  async function setMarker (location, noCenter) {
    await verifyMapObject()
    if (!mymap) {
      console.log('[WARN] map object is not initialized')
      return
    }
    // // TODO: remove it
    // return

    // clean old marker
    // const oldMarker = markers[previous]
    // if (oldMarker != null) {
    //   oldMarker.setIcon(new L.Icon.Default)
    // }
    if (lastSelectedMarker != null) {
      lastSelectedMarker.removeFrom(mymap)
    }

    if (location.lat == null || location.lon == null) {
      return
    }
    const xy = [location.lat, location.lon]

    // setup new marker
    lastSelectedMarker = L.marker(xy).on('click', markerClickHandler)
    lastSelectedMarker.bindPopup(location.eu_name)
    lastSelectedMarker.location_id = location.id
    lastSelectedMarker.setIcon(activeIcon)
    lastSelectedMarker.addTo(mymap)

    if (noCenter) {
      // return
    }
    //if (!detailsForm && !isFitMapBounds(location)) {
    //  mymap.setView(xy)
    //}
  }

  function markerClickHandler (event) {
    locationDblClickHandler({detail: {no: event.target.location_id}})

    // selected = event.target.location_id
    // console.log('[DEBUG] marker click', event)
  }

  function locationClickHandler ({detail}) {
    // console.log('[DEBUG] selected', [detail.su_erp_proj, detail.lat, detail.lon])
    // console.log('[DEBUG] detail', detail.no, detail)
    previous = selected
    selected = detail.no
  }

  async function locationDblClickHandler ({detail}) {
    // console.log('[DEBUG] dblClick', detail)
    previous = selected
    selected = detail.no
    form = true
  }

  let cookieTimout

  async function verifyMapObject () {
    for (let i = 0; i < 20; i++) {
      if (mymap) {
        console.log('[DEBUG] mymap is defined, return', mymap)
        return
      }
      if (L && L.map) {
        try {
          mymap = L.map('mapid', {minZoom: 1, maxZoom: 15})
        } catch (err) {
          //console.log('[ERROR] map setView !', err.message)
        }
      }
      //console.log('[DEBUG] init mymap retry after timout, ' + i)
      await sleep(100)
    }
  }

  function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  async function mapBox () {
    const license = 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
      '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
      'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'

    await verifyMapObject()

    if (!mymap) {
      console.log('[WARN] map object is not initialized')
    }

    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: license,
      maxZoom: 18,
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: 'pk.eyJ1IjoiYWVwZXRlbGluIiwiYSI6ImNrZWE0Zzg1MjA2encyc256ZXBhMTNhZzQifQ.Rq2EzpsMa_kVIBXyKgoKsg'
    }).addTo(mymap)

    cluster = new MarkerClusterGroup({
      animate: false,
      showCoverageOnHover: true,
      singleMarkerMode: false,
      chunkedLoading: true,
      spiderfyOnMaxZoom: false
    })
    mymap.addLayer(cluster)
    console.log('[DEBUG] create marker cluster ...', cluster)


    const setMapBounds = (event) => {
      const t = event.target
      clearTimeout(cookieTimout)
      cookieTimout = setTimeout(() => {
        const value = JSON.stringify({zoom: t._zoom, ...t._lastCenter})
        console.log('[DEBUG] value', value)
        setCookie('map', value)
        console.log('[DEBUG] cookie map saved!',)
      }, 1000)

      // mymap.fitBounds(locations)
      getBounds()
      // console.log('[DEBUG] zoom', { south, north, west, east})
    }

    mymap.on('zoomend', setMapBounds)
    mymap.on('moveend', setMapBounds)

  }

  function getBounds () {
    if (!mymap) return
    try {
      const bounds = mymap.getBounds()
      north = bounds.getNorth()
      south = bounds.getSouth()
      east = bounds.getEast()
      west = bounds.getWest()
    } catch (err) {
      console.log('[ERROR]', err)
    }
  }

  function updateMap (locations) {
    const layers = []
    // console.log(new Date().getMilliseconds(), '[DEBUG] update ...', )
    if (cluster == null || cluster.clearLayers == null) {
      return
    }

    cluster.clearLayers() // removeLayer(...)
    locations.forEach(l => {
      if (l.lat == null || l.lon == null) {
        return
      }
      const xy = [l.lat, l.lon]
      const marker = L.marker(xy).on('click', markerClickHandler)
      markers[l.id] = marker
      marker.bindPopup(l.eu_name)
      marker.location_id = l.id
      layers.push(marker)
    })
    cluster.addLayers(layers, true)
    // console.log(new Date().getMilliseconds(), '[DEBUG] clustered', )
  }

  async function getData () {
    locationsPromise = api[locationsHandler]()
      .then(res => {
        if (res.data != null && Array.isArray(res.data)) {
          locations = res.data
          locations.forEach(l => {
            setLocationID(l)
            if (l.m_modified) {
              l.m_modified_fmt = l.m_modified.slice(0, 10)
            }
            l.is_sat = l.SATDate != null && l.SATDate !== '' ? 'Yes' : 'No'

            if (l.lat == null || l.lon == null) {
              l.lat = '57.728473'
              l.lon = '12.021024'
            }

          })
          filtered1 = [...locations]
          loading = false
        } else {
          console.log('[DEBUG] something is wrong')
        }
      })
      .catch(err => console.log('[ERROR]', err.message))
  }

  function editDataItem ({detail}) {
    edit = true
  }

  function saveDataItem ({detail}) {
    selectedLocation = detail // TODO: wtf ???
    api.saveProject(detail.project)
      .then(res => {
        console.log('[DEBUG] project saved:', res.data, detail.project.su_erp_proj)
        detail.project.lat = res.data.lat
        detail.project.lon = res.data.lon
      })
      .catch(err => {
        console.log('[DEBUG] saveDataItem, project:', err)
      })
  }

  function onRowUpdate ({detail}) {
    const {column, item, value} = detail
    const index = locations.findIndex(i => i.no === item.no)
    locations[index][column.field] = value
  }

  function rowActionHandler ({detail}) {
    if (detail.action.name === 'open') {
      detailsForm = detail.item
    } else if (detail.action.name === 'locate') {
      previous = selected
      selected = detail.item.no
    } else {
      dispatch('action', detail)
    }
  }

  function tableFilteredHandler ({detail}) {
    updateMap([...detail])
  }
</script>

<div class="bg-white w-full mt-10 relative">
  <FiltersComp {showFilters}
               origin={locations}
               bind:filters={filters}
               bind:filtered={filtered1}
               on:close={() => { showFilters = !showFilters }}
  />

  <div class="main" style={`margin-left:${showFilters ? 280 : 0}px`}>

    <!-- header with map -->
    <div class="flex flex-row flex-wrap">

      <div class="w-full md:w-1/3 lg:w-1/4 px-8 shrink-0 flex items-start content-start header">

        <div class="m-auto mt-12 text-left flex flex-col h-4/5">
          <div class="text-black text-xl pb-2">INSTALLED BASE</div>
          <div class="text-gray-500 text-xl pb-4">{selected ? locationLabel + ' ' + selected : ''}</div>
          <div class="border-t text-gray-500 pt-3">Found: {filteredByMap.length}</div>
          {#if selectedLocation != null}
            <div class="pt-5 text-gray-500 text-lg">
              <div class="pb-1">
                {selectedLocation.eu_name ? selectedLocation.eu_name : selectedLocation.sales_unit}
              </div>
              <div class="pb-1">
                {(selectedLocation.eu_city ? selectedLocation.eu_city + ', ' : '') + selectedLocation.eu_country}
              </div>
              <div class="pb-1">
                {selectedLocation.sat_sig ? 'Installation date: ' + selectedLocation.sat_sig : ''}
              </div>
            </div>

            {#if selectedLocation.p_modified_by != null && selectedLocation.p_modified_by !== ''}
              <div class="py-2 text-gray-500 text-base">
                <div class="pb-1">
                  Modified by {selectedLocation.p_modified_by}, {selectedLocation.p_modified.slice(0, 10)}
                </div>
              </div>
            {/if}
          {/if}

          {#if !detailsForm}
            <div class="pt-2 pb-0 font-light">
              <Button text color="red"
                      style="margin-left: -12px"
                      on:click={() => { showFilters = !showFilters}}>
                {showFilters ? '' : 'Show filters'}
                {#if !showFilters && locations.length !== filtered1.length}
                <div class="ml-2 inline text-red-300 text-lg">
                  <Icon icon={faExclamationCircle} />
                </div>
                {/if}
              </Button>
            </div>

            <div>
              <slot name="action-buttons">
                &nbsp;
              </slot>
            </div>

            {#if is($userStore.roles, 'ib_admin', 'ib_supervisor')}
              <div class="flex flex-col flex-grow place-content-end">
                <BlueButton trackingID={'installed_base.Export_to_CSV'}
                            add="w-full mb-2 h-12"
                            text="Export filtered items"
                            on:click={() => {showConfirmationDialog = true}}
                />
              </div>
            {/if}
          {/if}

        </div>
      </div>

      <div class="relative w-full md:w-2/3 lg:w-3/4 flex-grow map bg-white" style="height: 350px">
        {#if $userStore.username != null}
          <div id="mapid" style="height: 350px"></div>
          <div class="w-16 absolute top-0 left-0 pt-32 mapinfo" style="z-index: 500">
            <div class="w-10 h-10 rounded-full bg-gray-50 text-lg text-red-300
                        shadow-2xl border border-gray-500 hover:elevation-2">
              <div style="line-height: 2.2rem">
                <Icon icon={faInfo} />
              </div>
            </div>
            <div class="mapinfo-text bg-white rounded-md elevation-3 items-center justify-center">
              <div class="text-gray-700">Map is acting as a filter</div>
            </div>
          </div>
        {/if}
      </div>
    </div>

    <!-- details table -->
    <div class="bg-white">
      {#if !detailsForm }
        <div class="locations text-gray-700 overflow-y-auto select-none">
          <DataTable data={filteredByMap} {columns} {actions} {actionsLabel}
                     dataPromise={locationsPromise}
                     activationColumn={0}
                     sortBy={columns[0]}
                     filterable={false}
                     current={selected}
                     minWidth={1024}
                     on:selected={locationClickHandler}
                     on:dblclick={locationDblClickHandler}
                     on:action={rowActionHandler}
                     on:filtered={tableFilteredHandler}
          />
        </div>
      {:else}
        <EditForm bind:data={detailsForm} {columns} {edit}
                  on:close={() => {detailsForm = null}}
                  on:edit={editDataItem}
                  on:save={saveDataItem}
        />
      {/if}
    </div>
  </div>
  <ConfirmationPopup bind:proceedConfirmed bind:show={showConfirmationDialog}/>
</div>

<style>
    .base-list {
        height: 500px;
    }

    .base-list:hover {
        cursor: pointer;
    }

    .main {
        transition: all 0.5s;
    }

    .filters-panel {
        width: 250px;
        z-index: 1;
        transition: all 0.5s;
    }

    .close-btn {
        position: absolute;
        top: 0;
        right: 25px;
        font-size: 36px;
        margin-left: 50px;
    }

    .mapinfo {
        padding-left: 0.9rem;
    }

    .mapinfo .mapinfo-text {
        display: none;
        text-align: center;
        padding: 6px 10px;
        position: absolute;
        min-width: 25rem;
        min-height: 3.5rem;
        left: 2.5rem;
        top: 9.5rem;
        /*top: -2em;*/

        /*z-index: 500;*/
    }

    .mapinfo:hover .mapinfo-text {
        display: flex;
    }
</style>
